import classNames from 'classnames';
import Surface from 'components/Surface';
import React from 'react';
import styles from './Container.module.scss';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  surface?: 1 | 2;
  spacingSize: 'none' | 'small' | 'medium' | 'large';
  alignContent: 'default' | 'center';
  noVerticalPadding?: boolean | null | undefined;
  /** Should this container flex-grow inside a RootLayout?  */
  flexGrow?: boolean;
  sidebar?: 'left' | 'right';
  /** Force a width on container */
  width?: number | string;
  children?: React.ReactNode;

  /**
   * If true, a minimum amount of padding (defined by the $spacing variable) will always be applied,
   * even on narrow resolutions.
   */
  includeMinimumPadding?: boolean;
}

export const Container = (props: ContainerProps) => {
  const {
    children,
    className,
    alignContent,
    spacingSize,
    flexGrow = false,
    sidebar,
    width,
    noVerticalPadding,
    includeMinimumPadding,
    surface = 1,
    ...rest
  } = props;

  // Offset container for variations of Header.height=default|short|tall

  const containerClass = classNames(
    styles.container,

    styles[`sidebar-on-the-${sidebar}`],
    styles[`spacing-${spacingSize}`],
    styles[`align-content-${alignContent}`],
    className,
    {
      [styles.noVerticalPadding]: noVerticalPadding,
      [styles.flexGrow]: flexGrow,
      [styles.includeMinimumPadding]: includeMinimumPadding,
    }
  );
  return (
    <Surface
      surface={surface}
      {...rest}
      style={{ width, ...rest.style }}
      className={containerClass}
    >
      {children}
    </Surface>
  );
};
Container.defaultProps = {
  spacingSize: 'medium',
  alignContent: 'default',
};
